import { Box, Card, CardContent, Typography } from "@mui/material";
import { ChartsAxisContentProps, BarSeriesType } from "@mui/x-charts";
import { TFunction } from "i18next";
import NumberFormatterUtils from "../../utils/numberFormatterUtils";

const BarChartWithBselineTooltip = (
  props: ChartsAxisContentProps,
  t: TFunction<[string, string], undefined>,
  subTotal?: number
) => {
  // console.log("from, data", props);
  const index = props.dataIndex ?? 0;

  // เก็บข้อมูล series ที่จะแสดงใน tooltip
  const seriesData: Array<{
    label: string;
    value: number;
    color: string;
  }> = [];

  props.series.forEach((item) => {
    const barItem = item as BarSeriesType;
    const data = item.data[index];

    if (typeof data === "number" && barItem.label) {
      seriesData.push({
        label: typeof barItem.label === "string" ? barItem.label : "",
        value: data,
        color: barItem.color || "#666",
      });
    }
  });

  // ถ้าไม่มีข้อมูลให้แสดง
  if (seriesData.length === 0) {
    return <Box></Box>;
  }

  return (
    <Card
      sx={{
        bgcolor: "var(--white)",
        borderRadius: "8px",
        minWidth: "200px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        border: "1px solid #e0e7ff",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        {/* Header - Category Name */}
        <Typography
          variant="h3"
          color={"dark"}
          sx={{
            fontWeight: 500,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          {t(props.axisValue?.toString() || "")}
        </Typography>

        {/* Year */}
        <Typography
          variant="h3"
          color={"dark"}
          sx={{
            fontWeight: 500,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          2024
        </Typography>

        {/* Series Data */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {seriesData.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                py: 0.5,
              }}
            >
              {/* Color Indicator */}
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  bgcolor: item.color,
                  borderRadius: "2px",
                  flexShrink: 0,
                }}
              />

              {/* Label */}
              <Typography
                variant="body2"
                color={"dark"}
                sx={{
                  fontWeight: 400,
                  flexGrow: 1,
                }}
              >
                {t(item.label)}
              </Typography>

              {/* Value */}
              <Typography
                variant="body2"
                color={"dark"}
                sx={{
                  fontWeight: 400,
                  minWidth: "40px",
                  textAlign: "right",
                }}
              >
                {NumberFormatterUtils.formatDynamic(item.value)}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default BarChartWithBselineTooltip;
